<template>
    <section class="o-page-bottom-spacing--medium">

        <page-header>
            <slot slot="title">{{ $t('country_overview.page_title') }}</slot>
        </page-header>

        <v-overview-list
            prefix="a1"
            data-table="CountryOptions"
            btnViewPath="CountriesEdit"
            :table-columns="Columns"
            :page-size="100">
        </v-overview-list>

    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VSelect from '@/components/form/Select'
    import VOverviewList from '@/components/OverviewList'

    export default {
        components: {
            PageHeader,
            VSelect,
            VOverviewList
        },
        data() {
          return { }
        },
        computed: {
            Columns() {
                return [
                  {
                      value: 'OverviewName',
                      name: this.$t('country_overview.columns.name'),
                      sortable: false
                  },
                  {
                      value: "Iso2",
                      name: this.$t('country_overview.columns.iso_code'),
                      sortable: false
                  },
                  {
                      value: 'IsAvailable',
                      name: this.$t('country_overview.columns.is_available'),
                      type: 'Boolean',
                      sortable: false
                  }
              ];
            }
        },
        methods: {}
    }
</script>


// WEBPACK FOOTER //
// src/views/admin/countries/Overview.vue